export abstract class FeedbackPort {
  abstract hideLoading(): void;
  abstract showLoading(loadingTextKey?: string): void;
  abstract showError(errorTitleKey: string): void;
}
